import HomeIcon from "./HomeIcon"
import ProfileIcon from "./ProfileIcon"
import VisaIcon from "./VisaIcon"
import FlightIcon from "./FlightIcon"
import DocumentsIcon from "./DocumentsIcon"
import InsuranceIcon from "./InsuranceIcon"
import EventsIcon from "./EventsIcon"
import PaymentsIcon from "./PaymentsIcon"
import NotificationsIcon from "./NotificationsIcon"
import MessagesIcon from "./MessagesIcon"
import HelpIcon from "./HelpIcon"
import SettingsIcon from "./SettingsIcon"
import SwitchIcon from "./SwitchIcon"
import LogoutIcon from "./LogoutIcon"
import PerksIcon from "./PerksIcon"
import ReferralsIcon from "./ReferralsIcon"
import WorkPermitsIcon from "./WorkPermitsIcon"
import CoursesIcon from "./CoursesIcon"
import ParticipantMonitoringIcon from "./ParticipantMonitoringIcon"
import JobAdsIcon from "./JobAdsIcon"
import EllipsisIcon from "./EllipsisIcon"
import CampsIcon from "./CampsIcon"
import ResortsIcon from "./ResortsIcon"
import LinkedApplicationIcon from "./LinkedApplicationIcon"
import SearchIcon from "./SearchIcon"
import NeedsIcon from "./NeedsIcon"
import PlacementsIcon from "./PlacementsIcon"
import FinancialsIcon from "./FinancialsIcon"
import PublicProfileIcon from "./PublicProfileIcon"
import FeedbackIcon from "./FeedbackIcon"
import ArrivalsIcon from "./ArrivalsIcon"
import DirectHireIcon from "./DirectHireIcon"
import InformationIcon from "./InformationIcon"
import InterviewsIcon from "./InterviewsIcon"
import PoliceCheckIcon from "./PoliceCheckIcon"
import FeeSheetIcon from "./FeeSheetIcon"
import CommunityIcon from "./CommunityIcon"
import LiveChatIcon from "./LiveChatIcon"
import ManageUsersIcon from "./ManageUsersIcon"

const NavIcons = {
  ArrivalsIcon,
  CampsIcon,
  CommunityIcon,
  CoursesIcon,
  DirectHireIcon,
  DocumentsIcon,
  EllipsisIcon,
  EventsIcon,
  FeedbackIcon,
  FeeSheetIcon,
  FinancialsIcon,
  FlightIcon,
  HelpIcon,
  HomeIcon,
  InformationIcon,
  InsuranceIcon,
  InterviewsIcon,
  JobAdsIcon,
  LinkedApplicationIcon,
  LiveChatIcon,
  LogoutIcon,
  MessagesIcon,
  NeedsIcon,
  NotificationsIcon,
  ParticipantMonitoringIcon,
  PaymentsIcon,
  PerksIcon,
  PlacementsIcon,
  PoliceCheckIcon,
  ProfileIcon,
  PublicProfileIcon,
  ReferralsIcon,
  ResortsIcon,
  SearchIcon,
  SettingsIcon,
  SwitchIcon,
  VisaIcon,
  WorkPermitsIcon,
  ManageUsersIcon
}

export default NavIcons
